import {NgModule} from '@angular/core';

import {UserNameComponent} from './index';
import {IonicModule} from 'ionic-angular';

/**
 * Module for the username component
 */
@NgModule({
  declarations: [UserNameComponent],
  exports: [UserNameComponent],
  imports: [IonicModule],
  providers: [],
})
export class UserNameModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/components/user-name/user-name.module.ts